export function getFullOffsetTop(view: HTMLDivElement, refSelector = 'main.app') {
  const scrollView = document.querySelector(refSelector) as HTMLDivElement;
  let offsetParent = view;
  let viewPos = 0;
  do {
    if (offsetParent) {
      viewPos += offsetParent.offsetTop;
    }
    offsetParent = offsetParent?.offsetParent as HTMLDivElement;
  } while (offsetParent && offsetParent !== scrollView);

  return viewPos;
}
